import RfmBandFields from './rfm-band-fields';

type CardValueFormProps = {
  enableForm: boolean;
};

export function CardValueForm({ enableForm }: CardValueFormProps) {
  return <RfmBandFields dimension="value" enableForm={enableForm} />;
}
